import { createGetPropGetter } from '@/store/utils';

export default {
  paginationItemsPerPageByTabs: createGetPropGetter('paginationItemsPerPageByTabs',
    {
      topLevelDomain: 20,
      infrastructure: 20,
      cloud: 20,
      cloudAccount: 20,
      employees: 20,
      technologies: 20,
      bucket: 20,
      services: 20,
      projects: 20,
      centralizedIssues: 20,
      reports: 20,
      leaks: 20,
    }),
  cloudAccountsPaginationState: createGetPropGetter('cloudAccountsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  projectsPaginationState: createGetPropGetter('projectsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  centralizedIssuesPaginationState: createGetPropGetter('centralizedIssuesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  integrationsPaginationState: createGetPropGetter('integrationsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  highlightReportsPaginationState: createGetPropGetter('highlightReportsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  servicesAssetsPaginationState: createGetPropGetter('servicesAssetsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  topLevelDomainsPaginationState: createGetPropGetter('topLevelDomainsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  infrastructurePaginationState: createGetPropGetter('infrastructurePaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  leaksPaginationState: createGetPropGetter('leaksPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  employeesPaginationState: createGetPropGetter('employeesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  technologiesPaginationState: createGetPropGetter('technologiesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  cloudInstancesPaginationState: createGetPropGetter('cloudInstancesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  cloudBucketsPaginationState: createGetPropGetter('cloudBucketsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  infostealersPaginationState: createGetPropGetter('infostealersPaginationState', {
    page: 1,
    itemsPerPage: 20,
    total: 0,
    hasNext: false,
    hasPrevious: false,
    totalPages: 1,
  }),
};
